export default __webpack_public_path__ + "static/media/icon_trans.7e590530.png";